import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1.5" }


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeWithStatus',
  props: {
    employeeName: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["size-3 rounded-full", _ctx.employeeName ? 'bg-accent' : 'bg-destructive'])
    }, null, 2),
    _createElementVNode("span", null, _toDisplayString(_ctx.employeeName || _ctx.$t('payrolls.existing.not_approved')), 1)
  ]))
}
}

})